import axios from "axios";
import snapshot from "@/data/snapshot.json";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ipsita_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Try the live API first; fall back to the bundled content snapshot so the
// static Hostinger build works fully without a backend.
export const fetchContent = async (path) => {
  try {
    const r = await api.get(path);
    return r.data;
  } catch {
    if (path in snapshot) return snapshot[path];
    return path.startsWith("/content") ? {} : [];
  }
};
